import styles from './main-section-news.module.css'
import CardSliderNewsMain from "../card-slider-news-main/card-slider-news-main";
import {NavLink} from "react-router-dom";
function MainSectionNews() {



    return (
        <section className={styles.container}>
            <div className={styles.boxText}>
                <div className={styles.h3}>Новости</div>
                <NavLink to={'/analytics-and-news'} className={styles.link}>
                    <button className={styles.newsBtn}>
                        <p className={styles.textBtn}>Смотреть больше</p>
                    </button>
                </NavLink>
            </div>
            <CardSliderNewsMain />
        </section>
    )
}

export default MainSectionNews